import { ToolbarGroup, Button } from '@wordpress/components';
import {
  BlockControls as CoreBlockControls,
  AlignmentControl,
} from '@wordpress/block-editor';

export default function BlockControls({
  context,
  clientId,
  attributes,
  setAttributes,
}) {
  const handleSyncLayout = () => {
    window.dispatchEvent(
      new CustomEvent('brandySyncTestimonialsLayout', {
        detail: {
          rootId: context.rootId,
          singleId: context.singleTestimonialId,
          syncBlocks: ['description'],
          blockId: clientId,
        },
      })
    );
  };
  return (
    <CoreBlockControls group="block">
      <ToolbarGroup>
        <Button isPrimary onClick={handleSyncLayout}>
          Apply styles to all descriptions
        </Button>
      </ToolbarGroup>
      <AlignmentControl
        value={attributes.align ?? 'left'}
        onChange={(newAlign) =>
          setAttributes({
            align: newAlign,
          })
        }
      />
    </CoreBlockControls>
  );
}
